export const notificationDrawer = {
  notificationDrawerTitle: "通知",
  notificationDrawerDeleteBtn: "删除",
  notificationDrawerDeletedNotification: "通知已删除",
  notificationDrawerDeletedFailed: "通知删除失败",
  notificationMarkReadFailed: "通知标记为已读失败",
  notificationDrawerNotifications: "没有通知",
  notificationDrawerPlay: "打游戏",
  notificationDrawerPlayGame: "前往游戏",
  notificationClose: "关闭",
  notificationJustNow: "刚刚",
  notificationMarkRead: "标记为已读",
  notificationTagNews: "新闻",
  notificationTagPush: "通知",
  notificationTagBreaking: "促销活动",
  notificationTagMovement: "交易",
  notificationTab_all: "全部",
  notificationTab_news: "新闻",
  notificationTab_breaking: "促销活动",
  notificationTab_movements: "交易",
  notificationEmptySubtext: "当您有新通知时，它们将在此显示",
  notificationNewsCta: "点击了解更多",
};
